<template>
  <div class="UnServer">
    <div class="form1">
        <el-form :model="addForm" ref="addForm" label-width="120px" :rules="rules"
            :inline="false" class="demo-ruleForm" size="mini">
            <el-form-item prop="unserveremail" label="邮箱" v-show="addForm.unserverkbn!=='03'">
                <el-input v-model="addForm.unserveremail"></el-input>
            </el-form-item>
            <el-form-item label="获取码" prop="sshqm" v-show="addForm.unserverkbn!=='00'">
                <el-input v-model="addForm.sshqm"></el-input>
            </el-form-item>
            <template>
                <el-radio v-model="addForm.unserverkbn" label="00">全站</el-radio>
                <el-radio v-model="addForm.unserverkbn" label="01">指向区分</el-radio>
                <el-radio v-model="addForm.unserverkbn" label="02">提取码</el-radio>
                <el-radio v-model="addForm.unserverkbn" label="03">智能</el-radio>
            </template>
        </el-form>
        <br>
        <el-form :inline="true"> 
            <el-form-item class="as_btn">
                <el-button type="primary" @click="submitForm()" :disabled="btnFlag">开始拒服</el-button>
            </el-form-item>
        </el-form>
      </div>
      <el-table :data="emuOWebtList" stripe style="width: 100%" size="mini" border>
            <el-table-column prop="unserveremail" label="unserveremail" > </el-table-column>
            <el-table-column prop="unserverkbn" label="unserverkbn" > </el-table-column>
            <el-table-column prop="sshqm" label="sshqm" > </el-table-column>
        <el-table-column label="操作" width="180">
            <template>
                <el-button size="mini" @click="unuse" >编辑</el-button>
                <el-button size="mini" type="danger"  @click="unuse">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'UnServer',
  data(){
    return {
      addForm:{
        unserveremail:'',//模拟器内部名CD
        sshqm:'',//模拟器内部名
        unserverkbn: '00'
      },
      emuOWebtList:[],
      rules: {
          unserveremail: [
              { required: true, message: '不能为空', trigger: 'blur' }
          ],
          sshqm: [
              { required: true, message: '不能为空', trigger: 'blur' }
          ]
      },
      btnFlag: false
    };
  },
  props: {
    msg: String
  },
  methods:{
    showAll(){
        let _this = this;
        this.$axios.post('/ssBaseS3Controller/getUnservered.do',)
        .then(res => {
            _this.emuOWebtList = res.emuOWebtList;
        })
    },
    submitForm(){
        let _this = this;

          if((_this.addForm.unserverkbn !== '00' && !_this.addForm.sshqm) ||
             (_this.addForm.unserverkbn !== '03' && !_this.addForm.unserveremail)) {
              _this.$message({//消息提示框
                                  message: '拒服参数不对',
                                  type: 'error',
                                  showClose: true,//是否有关闭按钮
                                  duration: 1000 //持续时间
                });
             }else{
            this.$axios.post('/ssBaseS3Controller/doUnserver.do', {..._this.addForm,})
              .then(res => {
                // console.log(res);
                _this.$message({//消息提示框
                                  message: '拒服成功',
                                  type: 'success',
                                  showClose: true,//是否有关闭按钮
                                  duration: 1000 //持续时间
                });
                _this.showAll()
              })
          }
    },
    unuse(){
      this.$message({ message: '不支持的功能', type: 'error', showClose: true, duration: 1000 });
    }
    
  },
  created:function () {
    this.showAll();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
